import $ from 'jquery'

export default {
    name: 'manage-mode-administration',
    components: {},
    props: {
        modal_title: String,
        user_id: Number,
        active_role: String,
        selected_mode: Object
    },
    data() {
        return {
            mode_administration: {
                id: 0,
                data_type: 'mode_administration',
                designation: ''
            },
            save_loading: false,
            del_loading: false,
            is_confirm: false,

            is_error: false,
            permission_is_denied: false,
            error_message: ''
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        async submit() {
            this.clearError()
            const isValid = await this.$refs.administration_mode_form.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true
            const data = {
                user_id: this.user_id,
                active_role: this.active_role,
                id: this.selected_mode.id,
                designation: this.mode_administration.designation,
                data_type: 'mode_administration'
            }

            this.$store.dispatch('saveModeAdministration', data).then((response) => {
                if (response.success) {
                    this.successToast("Ajout effectué avec succès")
                    this.$emit('emitMode')

                    this.mode_administration = {
                        id: 0,
                        data_type: 'mode_administration',
                        designation: ''
                    }

                    this.$refs.administration_mode_form.reset()
                    this.$refs.mode_administration_mdl.click()
                } else {
                    this.is_error = true
                    if (response.code === 409) {
                        this.error_message = "Ce mode d'administration existe déjà !"
                    } else if (response.code === 401) {
                        this.error_message = "Impossible d'effectuer cette opération !"
                    } else if (response.code === 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
                this.error_message = "Une erreur s'est produite !"
            })
        },

        clearError() {
            this.is_error = false
            this.error_message = ''
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true
            this.selected_mode.user_id = this.user_id
            this.selected_mode.active_role = this.active_role
            console.log(this.selected_mode);

            this.$store.dispatch('deleteModeAdministration', this.selected_mode).then((response) => {
                if (response.success) {
                    this.successToast('Suppression effectué avec succès')
                    this.$emit('emitMode')

                    this.$refs.del_mode.click()
                } else {
                    this.is_error = true
                    if (response.code === 401) {
                        this.error_message = "Impossible d'effectuer cette opération !"
                    } else if (response.code === 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                
                this.del_loading = false;
                this.is_confirm = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
                this.error_message = "Une erreur s'est produite !"
            })
        },
    }
}


